import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FormatService {
  GetFormatedDate(date: Date, isRTL: boolean, checkLanguage: boolean): string {
    var dd = date.toString().substring(8, 10);
    var MM = date.toString().substring(5, 7); //January is 0!
    var yyyy = date.toString().substring(0, 4);
    var hh = date.toString().substring(11, 13);
    var mm = date.toString().substring(14, 16);
    var formatedDate = '';
    if (isRTL == false || checkLanguage == false)
      formatedDate = MM + '/' + dd + '/' + yyyy + ' ' + hh + ':' + mm;
    else formatedDate = dd + '/' + MM + '/' + yyyy + ' ' + hh + ':' + mm;
    return formatedDate;
  }

  GetShortFormatedDate(date: Date, isRTL: boolean): string {
    var dd = date.toString().substring(8, 10);
    var MM = date.toString().substring(5, 7); //January is 0!
    var yyyy = date.toString().substring(0, 4);
    var formatedDate = '';
    if (isRTL == false) formatedDate = MM + '/' + dd + '/' + yyyy;
    else formatedDate = dd + '/' + MM + '/' + yyyy;
    return formatedDate;
  }

  GetShortDateTime(date: Date, isRTL: boolean): string {
    var dd = date.toString().substring(8, 10);
    var MM = date.toString().substring(5, 7); //January is 0!
    var hh = date.toString().substring(11, 13);
    var mm = date.toString().substring(14, 16);
    var formatedDate = '';
    if (isRTL == false) formatedDate = MM + '/' + dd + ' ' + hh + ':' + mm;
    else formatedDate = dd + '/' + MM + ' ' + hh + ':' + mm;
    return formatedDate;
  }

  GetShortDate(date: Date): string {
    var dd = date.toString().substring(8, 10);
    var MM = date.toString().substring(5, 7); //January is 0!
    var yyyy = date.toString().substring(0, 4);
    var formatedDate = MM + '/' + dd + '/' + yyyy;
    return formatedDate;
  }

  GetDBOFormat(date: Date): string {
    if (!date) return "";
    var monthArr: string[] = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    var dd = date.toString().substring(8, 10);
    var MM = date.toString().substring(5, 7); //January is 0!
    var formatedDate = monthArr[parseInt(MM) - 1] + '-' + dd;
    return formatedDate;
  }
}
